export class PaymentProfileAdd
{
      AnetProfileID: string;
      CustomerID: string;
      UserID: string;
      isTest: boolean;
}
